import { POSTS } from "@/lib/blogMeta.generated";
import CoverImage from "@/components/CoverImage";

const ff = "'Barlow', 'Barlow Fallback', sans-serif";

type Post = typeof POSTS[0];

function getCat(post: Post) {
  return post.categories[0]
    ? post.categories[0].replace(/-/g, " ").replace(/\w/g, (c) => c.toUpperCase())
    : "SEO";
}

export default function HomeBlogSection({ isMobile }: { isMobile: boolean }) {
  const sorted = [...POSTS].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
  const featured = sorted[0];
  const side = sorted.slice(1, 3);

  return (
    <section className="section-grid" style={{ background: "#0c0c0c", padding: isMobile ? "60px 20px" : "100px 72px" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: "24px", marginBottom: "56px" }}>
          <h2 style={{ color: "white", fontSize: isMobile ? "32px" : "48px", fontWeight: 700, fontFamily: ff, margin: 0, lineHeight: 1.1, textAlign: "left" as const }}>
            From the<br /><span style={{ color: "#57d7e2" }}>Indexed blog.</span>
          </h2>
          <a
            href="/blog"
            style={{ color: "#57d7e2", fontSize: "16px", fontWeight: 600, fontFamily: ff, textDecoration: "none", transition: "opacity 0.2s" }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLAnchorElement).style.opacity = "0.7")}
            onMouseLeave={(e) => ((e.currentTarget as HTMLAnchorElement).style.opacity = "1")}
          >
            Read all →
          </a>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gridTemplateRows: "auto auto", gap: "20px" }}>
          {/* Featured post — spans 2 rows */}
          <a
            href={`/blog/${featured.slug}`}
            style={{ background: "#111111", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "16px", overflow: "hidden", textDecoration: "none", display: "flex", flexDirection: "column", transition: "border-color 0.2s, transform 0.2s", gridRow: "span 2" }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(87,215,226,0.25)"; (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(-2px)"; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(0)"; }}
          >
            <div style={{ position: "relative", overflow: "hidden" }}>
              {/* CoverImage, not a bare <img>: a cover that 404s becomes a
                  category-tinted panel instead of a broken-image icon. */}
              <div style={{ height: "260px" }}>
                <CoverImage post={featured} imgStyle={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              </div>
              <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "80px", background: "linear-gradient(to bottom, transparent, #111111)" }} />
            </div>
            <div style={{ padding: "32px", flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
              <span style={{ color: "#57d7e2", fontSize: "11px", fontWeight: 700, fontFamily: ff, letterSpacing: "0.1em", textTransform: "uppercase" as const }}>{getCat(featured)}</span>
              <h3 style={{ color: "white", fontSize: "22px", fontWeight: 700, fontFamily: ff, margin: 0, lineHeight: 1.3 }}>{featured.title}</h3>
              <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "15px", fontFamily: ff, lineHeight: 1.65, margin: 0, flex: 1 }}>{featured.excerpt}</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "8px" }}>
                <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "13px", fontFamily: ff }}>{featured.readingTime} min read</span>
                <span style={{ color: "#57d7e2", fontSize: "14px", fontWeight: 600, fontFamily: ff }}>Read more →</span>
              </div>
            </div>
          </a>
          {/* Side articles */}
          {side.map((art, i) => (
            <a
              key={i}
              href={`/blog/${art.slug}`}
              style={{ background: "#111111", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "16px", overflow: "hidden", textDecoration: "none", display: "flex", transition: "border-color 0.2s, transform 0.2s" }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(87,215,226,0.25)"; (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(-2px)"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(0)"; }}
            >
              <div style={{ width: "140px", flexShrink: 0 }}>
                <CoverImage post={art} imgStyle={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              </div>
              <div style={{ padding: "24px", display: "flex", flexDirection: "column", gap: "8px" }}>
                <span style={{ color: "#57d7e2", fontSize: "10px", fontWeight: 700, fontFamily: ff, letterSpacing: "0.1em", textTransform: "uppercase" as const }}>{getCat(art)}</span>
                <h3 style={{ color: "white", fontSize: "16px", fontWeight: 700, fontFamily: ff, margin: 0, lineHeight: 1.3 }}>{art.title}</h3>
                <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "13px", fontFamily: ff, lineHeight: 1.6, margin: 0, flex: 1 }}>{art.excerpt}</p>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "4px" }}>
                  <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "12px", fontFamily: ff }}>{art.readingTime} min read</span>
                  <span style={{ color: "#57d7e2", fontSize: "13px", fontWeight: 600, fontFamily: ff }}>Read more →</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
